import { Col, Container, Row } from 'react-bootstrap';
import { withRouter } from 'react-router';
import styled, { useTheme } from 'styled-components';

import { useCurrentUser } from '../../../hooks';
import { signOut } from '../../../utils/auth';
import AdminBar from '../../AdminBar';
import Footer from '../../Footer/Footer';
import MainNav from '../../MainNav';

import StyledNavbar from './Branded/StyledNavbar';

const StyledBackgroundDiv = styled.div`
  background: ${(props) => props.theme.colors.pale};
  overflow-x: hidden;
  width: 100%;
`;

const ContentDiv = styled.div`
  z-index: 0;
`;

const BrandedOnboardingLayout = ({ children, location }) => {
  const { user, isAdmin } = useCurrentUser();
  const theme = useTheme();

  return (
    <StyledBackgroundDiv
      fluid
      className="d-flex flex-column align-content-between justify-content-between login-background p-0 onboarding"
    >
      <div>
        {isAdmin && <AdminBar user={user} onSignOut={signOut} />}
        <Container fluid>
          <Row
            className={`p-0 onboarding-nav-container ${theme.layout.showOrHideElements.onBoarding.showMainNav ? '' : 'mt-5'}`}
          >
            <Col className="p-0">
              {theme.layout.showOrHideElements.onBoarding.showMainNav && (
                <StyledNavbar collapseOnSelect expand="lg">
                  <Container fluid="xl">
                    <MainNav
                      isLoginScreen={false}
                      showSignOut={true}
                      isAdmin={isAdmin}
                      user={user}
                      isOnboarding={true}
                    />
                  </Container>
                </StyledNavbar>
              )}
            </Col>
          </Row>
        </Container>
      </div>
      <div className="flex-fill">
        <Container fluid="lg">
          <Row>
            <Col>
              <ContentDiv className="d-flex justify-content-center p-sm-3 p-xs-1 pt-3">{children}</ContentDiv>
              <div className="mb-5"></div>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer location={location} />
    </StyledBackgroundDiv>
  );
};

export default withRouter(BrandedOnboardingLayout);
